import SyntaxHighlighter from 'react-syntax-highlighter/dist/esm/prism-light';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import oneDark from 'react-syntax-highlighter/dist/esm/styles/prism/one-dark';
import { copyText } from '../../../context/helper';
import { Button } from 'antd';
import { memo, useState } from 'react';
// FIX: import { emojify } not default
import { emojify } from 'node-emoji';

const copyBtnStyle = {
  position: 'absolute',
  top: '10px',
  right: '10px',
  background: 'rgb(47, 47, 47)',
  color: 'white',
};

const MemoisedSyntaxHighlighter = memo((props) => {
  const { children, ...rest } = props;
  return <SyntaxHighlighter {...rest}>{children}</SyntaxHighlighter>;
});

export default memo(({ content, i }) => {
  const [copy, setCopy] = useState('Copy');

  const copyFunc = (text) => {
    copyText(text);
    setCopy('Copied!');
    setTimeout(() => {
      setCopy('Copy');
    }, 2000);
  };

  // Replace all `:emoji_name:` with unicode emojis
  const emojiContent = emojify(content);

  return (
    <ReactMarkdown
      key={i}
      remarkPlugins={[remarkGfm]}
      components={{
        table({ children, ...props }) {
          return (
            <div style={{ overflowX: 'auto', marginBottom: '16px', maxWidth: '100%' }}>
              <table style={{ 
                borderCollapse: 'collapse', 
                width: '100%', 
                fontSize: '13px',
                border: '1px solid #e0e0e0'
              }} {...props}>
                {children}
              </table>
            </div>
          );
        },
        thead({ children, ...props }) {
          return (
            <thead style={{ backgroundColor: '#f5f5f5' }} {...props}>
              {children}
            </thead>
          );
        },
        th({ children, ...props }) {
          return (
            <th style={{ 
              padding: '10px', 
              textAlign: 'left', 
              borderBottom: '2px solid #d0d0d0',
              fontWeight: '600',
              whiteSpace: 'nowrap'
            }} {...props}>
              {children}
            </th>
          );
        },
        td({ children, ...props }) {
          return (
            <td style={{ 
              padding: '8px 10px', 
              borderBottom: '1px solid #e0e0e0'
            }} {...props}>
              {children}
            </td>
          );
        },
        code({ node, inline, className, children, ...props }) {
          const match = /language-(\w+)/.exec(className || '');
          return !inline && match ? (
            <div style={{ position: 'relative' }}>
              <Button style={copyBtnStyle} onClick={() => copyFunc(children)}>
                {copy}
              </Button>
              <MemoisedSyntaxHighlighter
                style={oneDark}
                language={match[1]}
                PreTag="div"
                {...props}
              >
                {String(children).replace(/\n$/, '')}
              </MemoisedSyntaxHighlighter>
            </div>
          ) : (
            <code className={className} {...props}>
              {children}
            </code>
          );
        },
        ul({ children, ...props }) {
          return (
            <ul
              style={{
                paddingLeft: '20px',
                listStyleType: 'disc',
                marginBottom: '1em',
              }}
              {...props}
            >
              {children}
            </ul>
          );
        },
        ol({ children, ...props }) {
          return (
            <ol
              style={{
                paddingLeft: '20px',
                listStyleType: 'decimal',
                marginBottom: '1em',
              }}
              {...props}
            >
              {children}
            </ol>
          );
        },
        li({ children, ...props }) {
          return (
            <li style={{ marginBottom: '4px' }} {...props}>
              {children}
            </li>
          );
        },
        p({ children, ...props }) {
          return (
            <p style={{ marginBottom: '0.75em' }} {...props}>
              {children}
            </p>
          );
        },
        pre({ children, ...props }) {
          return (
            <pre 
              style={{ 
                maxWidth: '100%',
                overflowX: 'auto',
                whiteSpace: 'pre',
                marginBottom: '1em'
              }} 
              {...props}
            >
              {children}
            </pre>
          );
        },
        table({ children, ...props }) {
          return (
            <div style={{ maxWidth: '100%', overflowX: 'auto', marginBottom: '1em' }}>
              <table 
                style={{ 
                  borderCollapse: 'collapse',
                  width: 'auto',
                  minWidth: '100%'
                }} 
                {...props}
              >
                {children}
              </table>
            </div>
          );
        },
        thead({ children, ...props }) {
          return (
            <thead style={{ background: '#f5f5f5' }} {...props}>
              {children}
            </thead>
          );
        },
        th({ children, ...props }) {
          return (
            <th 
              style={{ 
                border: '1px solid #d0d0d0',
                padding: '8px 12px',
                textAlign: 'left',
                fontWeight: 600,
                whiteSpace: 'nowrap'
              }} 
              {...props}
            >
              {children}
            </th>
          );
        },
        td({ children, ...props }) {
          return (
            <td 
              style={{ 
                border: '1px solid #e0e0e0',
                padding: '8px 12px',
                whiteSpace: 'nowrap'
              }} 
              {...props}
            >
              {children}
            </td>
          );
        },
      }}
    >
      {emojiContent}
    </ReactMarkdown>
  );
});
